export function formatVisitAt(iso) {
  if (!iso) return null;
  try {
    return new Date(iso).toLocaleDateString();
  } catch {
    return iso;
  }
}

export function formatTodayPill(date = new Date()) {
  try {
    const day = date.toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' });
    const time = date.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
    return `Today, ${day} · ${time}`;
  } catch {
    return date.toLocaleString();
  }
}

export function deriveGuestWelcomeVisit(profile) {
  const summary = profile?.history_summary || {};
  const lastVisit = summary?.last_visit;
  const summaryLocation = lastVisit?.services_summary?.location;
  const lastVisitLocation =
    lastVisit?.franchise ||
    summary?.last_visit_location ||
    (summaryLocation && typeof summaryLocation === 'object' ? summaryLocation : null) ||
    null;
  const lastVisitCity =
    lastVisitLocation?.city || lastVisit?.city || summaryLocation?.city || '';
  const lastVisitArea =
    lastVisitLocation?.area || lastVisit?.area || summaryLocation?.area || '';
  const lastVisitCountry =
    lastVisitLocation?.country || lastVisit?.country || summaryLocation?.country || '';
  const lastVisitState =
    lastVisitLocation?.state || lastVisit?.state || summaryLocation?.state || '';
  const lastVisitAddress =
    lastVisitLocation?.address || lastVisit?.address || summaryLocation?.address || '';
  const lastVisitFranchiseName =
    lastVisitLocation?.name ||
    lastVisit?.franchise_name ||
    summaryLocation?.name ||
    summaryLocation?.franchise_name ||
    '';
  const hasLastVisitLocation = Boolean(
    lastVisitCity ||
      lastVisitArea ||
      lastVisitCountry ||
      lastVisitState ||
      lastVisitAddress ||
      lastVisitFranchiseName,
  );
  const visitCount = Number(summary.visit_count ?? 0);
  const recognitionCount = Number(summary.recognition_count ?? 0);
  const isNewMember = visitCount <= 1 && recognitionCount <= 1;
  return {
    summary,
    lastVisit,
    lastVisitCity,
    lastVisitArea,
    lastVisitCountry,
    lastVisitState,
    lastVisitAddress,
    lastVisitFranchiseName,
    hasLastVisitLocation,
    visitCount,
    isNewMember,
  };
}

export function previousServicesFromProfileHistory(profile) {
  const visits = Array.isArray(profile?.history) ? profile.history : [];
  const fromVisits = [];
  visits.forEach((visit) => {
    const summaryPayload = visit?.services_summary;
    const selected =
      (summaryPayload && summaryPayload.selected_services) ||
      (summaryPayload && summaryPayload.services) ||
      [];
    (Array.isArray(selected) ? selected : []).forEach((item) => {
      const name = typeof item === 'string' ? item : item?.name;
      if (!name) return;
      fromVisits.push({
        id: `${visit.id || visit.visited_at}-${name}`,
        service_name: name,
        selected_at: visit.visited_at,
      });
    });
  });
  return fromVisits;
}
